export const ABBreakpointTabletStart = '768px';
